import { Controller } from "@hotwired/stimulus"
import axios from "axios"

// Służy do aktualizacji wartości pola po zmianie wartości innego pola
// - użycie w _form w helplink i entry
// Pozwalamy na wiele różnych kombinacji (pól śledzonych - `trigger` i aktualizowanych - `output`) w ramach jednego kontrolera

// wsparcie dla select, intum_select
// - Możliwość rozszerzania na inne typy pól w przyszłości
// - W implementacji zależny od intum_select

const defaultsOptions = {
  init: false,
}

export default class extends Controller {
  static targets = ["element"] // wspólne oznaczenie dla triggerów jak i outputów

  // opcje: (gdzie [...] oznacza dla jakich typów należy definiować opcję)

  // ogólne:
  // - kind        : string - typ elementu (logika wyzwalania zależna od typu)                                                                  [obowiązkowe]
  // - init        : bool   - czy na starcie wymusić aktywację triggera / aktualizację konkretnego pola                                         [opcjonalne]
  // - search_kind : string - nazwa pola, zazwyczaj wyszukiwania                                                                                [(*)]

  // opcje dla triggerów:
  // - triggers    : string[] - tablica triggerowanych outputów (ident)                                                                         [obowiązkowe]

  // opcje dla outputów:
  // - ident       : string - identyfikator, który może się znaleźć w triggers                                                                  [obowiązkowe]
  // - url         : string - w select bazowe URL do pobierania nowych danych np. get_section_list, w intum select to ścieżka do search         [intum_select, select]

  // (*) search_kind jest potrzebne w trigerze i outpucie, tylko gdy output z grupy triggerowanej jest typu [intum_select] (niezależnie od typu triggera)

  connect() {
    // ładujemy triggery i outputy z opcjami
    this.elements = Array.from(this.elementTargets).map(element => ({
      element,
      ...this.collectOptions(element, defaultsOptions)
    }))
    const toInit = []

    this.triggers = this.elements.filter(el => el.triggers !== undefined)
    this.outputs = this.elements.filter(el => el.ident !== undefined)

    // dodajemy listener'y do triggerów
    this.triggers.forEach((trigger) => {
      this.outputs.forEach((output) => {
        if (trigger.triggers.includes(output.ident)) {
          trigger.element.addEventListener("change", (_event) => this.afterChangeUpdate(trigger, output))
          if (trigger.init || output.init) {
            toInit.push({ trigger, output })
          }
        }
      })
    })

    // console.log("triggers:", this.triggers)
    // console.log("outputs:", this.outputs)

    // inicjalizujemy "zmianę" pól na starcie
    toInit.forEach(pair => this.afterChangeUpdate(pair.trigger, pair.output))
  }

  // opcje będą trzymane jako atrybuty
  collectOptions(element, defaults) {
    let attrs = {}
    try {
      attrs = JSON.parse(element.getAttribute("data-after-change-update-options")) || {}
    } catch (_e) {
      // błąd parsowania
      console.log("after_change_update: error parse options", element)
    }

    return { ...defaults, ...attrs }
  }

  afterChangeUpdate(trigger, output) {
    const searchId = this.getTriggerSearchId(trigger) || null

    switch (output.kind) {
      case "intum_select": {
        const sep = output.url.includes("?") ? "&" : "?"
        output.element.dataset.intumSelectSearchUrlValue = `${output.url}${sep}${trigger.search_kind}=${searchId}`

        output.element.querySelectorAll("[data-bubble]").forEach(bubble => bubble.remove())
        output.element.querySelectorAll(".hidden-fields-container input[type='hidden']").forEach(input => { input.value = "" })
        output.element.querySelector(`#${output.search_kind}_search`)?.dispatchEvent(new Event("input"))
        output.element.dispatchEvent(new Event("change", { bubbles: true }))
        break
      }
      case "select":
        axios.get(output.url, {
          params: { id: searchId },
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }
        })
          .then(response => {
            console.log(response.data)
            output.element.innerHTML = "<option value=\"\" label=\"\"></option>"
            if (!response.data) response.data = []

            response.data.forEach(element => { output.element.innerHTML += `<option value="${element}">${element}</option>` })
          })
          .catch(error => {
            console.log("after_change_update: error updating select", error)
          })
    }
  }

  getTriggerSearchId(trigger) {
    switch (trigger.kind) {
      case "select":
        return trigger.element.value
      case "intum_select":
        // z querySelectorAll przechodzimy się po wartościach z hidden containera i używamy join("") bo intum select potrafi dodać nadprogramowy pusty wpis w wartościach
        return Array.from(trigger.element.querySelectorAll(".hidden-fields-container input[type='hidden']")).map((i) => i.value).join("")
    }
  }
}
